import { Input } from "../../ui/shadcn/input";
import { Textarea } from "../../ui/shadcn/textarea";
import { Label } from "../../ui/shadcn/label";

interface ReportFormProps {
  projectName: string;
  projectDescription: string;
  onProjectNameChange: (value: string) => void;
  onProjectDescriptionChange: (value: string) => void;
  disabled?: boolean;
}

export function ReportForm({
  projectName,
  projectDescription,
  onProjectNameChange,
  onProjectDescriptionChange,
  disabled = false,
}: ReportFormProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Label htmlFor="project-name" className="text-sm font-medium">
          Nome do projeto
        </Label>
        <Input
          id="project-name"
          placeholder="Dê um nome ao projeto..."
          value={projectName}
          onChange={(e) => onProjectNameChange(e.target.value)}
          disabled={disabled}
        />
      </div>

      <div className="flex flex-col gap-2">
        <Label htmlFor="project-description" className="text-sm font-medium">
          Descrição do projeto
        </Label>
        <Textarea
          id="project-description"
          placeholder="Digite a descrição do projeto..."
          rows={3}
          value={projectDescription}
          onChange={(e) => onProjectDescriptionChange(e.target.value)}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
